import React, { useEffect } from 'react';

interface PopupProps {
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Popup: React.FC<PopupProps> = ({ show, onClose, children }) => {
  useEffect(() => {
    if (show) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="popup-overlay fixed top-0 left-0 w-screen h-screen bg-black/50 flex justify-center items-center z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="popup-content relative bg-white p-4 sm:p-6 md:p-8 lg:p-10 rounded-2xl shadow-2xl w-11/12 max-w-3xl h-11/12 max-h-[90vh] overflow-y-auto">
        <button
          className="close-button absolute top-4 right-4 w-8 h-8 bg-gray-100 hover:bg-gray-200 border-none rounded-full cursor-pointer text-gray-600 hover:text-gray-800 flex items-center justify-center transition-colors"
          onClick={onClose}
          aria-label="Close"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        {children}
      </div>
    </div>
  );
};

export default Popup;
